import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';

class ComicBook extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        let { content } = this.props;

        if (content.length > 0) {
            content = content[0];
        }

        return (
            <div className={styles.box}>
                <div className={styles.picTxt}>
                    <div className={styles.pic}>
                        <a href={content.url} target="_blank" rel={rel} title="连环话">
                            <img src={content.thumbnails} alt="连环话" className={styles.trans} />
                            <span>连环话</span>
                        </a>
                    </div>
                    <h3>
                        <a href={content.url} target="_blank" rel={rel} title={content.title}>
                            {content.title}
                        </a>
                    </h3>
                    <div className={styles.txt}>
                        <span>{content.date}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(ComicBook);
